import React from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './OurServiceArea.css';
import useScrollReveal from '../../hooks/useScrollReveal';
import messages from '../../../../locale/messages';

// Area names are place names, so they stay untranslated.
const areas = [
  {
    id: 'lombok',
    name: 'Lombok',
    desc: messages.homeAreaLombokDesc,
    image: '/SiteImages/lombok.webp',
    comingSoon: false,
  },
  {
    id: 'sumbawa',
    name: 'Sumbawa',
    desc: messages.homeAreaSumbawaDesc,
    image: '/SiteImages/sumbawa.webp',
    comingSoon: false,
  },
  {
    id: 'bali',
    name: 'Bali',
    desc: messages.homeAreaBaliDesc,
    image: '/SiteImages/bali.webp',
    comingSoon: true,
  },
];

function OurServiceArea() {
  useStyles(s);
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="service-area" className={s.serviceArea} ref={ref}>
      <div className={s.inner}>
        <p className={`${s.eyebrow} ${isVisible ? s.eyebrowVisible : ''}`}>
          <FormattedMessage {...messages.homeAreaEyebrow} />
        </p>
        <h2 className={`${s.title} ${isVisible ? s.titleVisible : ''}`}>
          <FormattedMessage {...messages.homeAreaTitle} />
        </h2>
        <p className={`${s.subtitle} ${isVisible ? s.subtitleVisible : ''}`}>
          <FormattedMessage {...messages.homeAreaSubtitle} />
        </p>

        <div className={s.grid}>
          {areas.map((area, i) => (
            <div
              key={area.id}
              className={`${s.card} ${isVisible ? s.cardVisible : ''}`}
              style={{ transitionDelay: isVisible ? `${0.2 + i * 0.12}s` : '0s' }}
            >
              <div className={s.imageWrap}>
                <img src={area.image} alt={area.name} className={s.image} />
                {area.comingSoon && (
                  <span className={s.badge}>
                    <FormattedMessage {...messages.homeComingSoon} />
                  </span>
                )}
              </div>
              <p className={s.cardTitle}>{area.name}</p>
              <p className={s.cardDesc}>
                <FormattedMessage {...area.desc} />
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default OurServiceArea;
